import { render, staticRenderFns } from "./ImageFolder.vue?vue&type=template&id=3e9c81fe&scoped=true&"
import script from "./ImageFolder.vue?vue&type=script&lang=js&"
export * from "./ImageFolder.vue?vue&type=script&lang=js&"
import style0 from "./ImageFolder.vue?vue&type=style&index=0&id=3e9c81fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9c81fe",
  null
  
)

export default component.exports